import { makeStyles } from '@material-ui/core';
import { Alert, Color } from '@material-ui/lab';
import React from 'react';

type InlineAlertProps = {
  children?: React.ReactNode;
  severity?: Color;
  variant?: 'standard' | 'filled' | 'outlined';
  icon?: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `0 ${theme.spacing(1.5)}px`,
  },
}));

const InlineAlert: React.FC<InlineAlertProps> = ({
  children,
  severity,
  variant = 'outlined',
  icon,
}) => {
  const classes = useStyles();
  return (
    <Alert
      className={classes.root}
      severity={severity}
      variant={variant}
      icon={icon}
    >
      {children}
    </Alert>
  );
};

export default React.memo(InlineAlert);
